<template>
    <transition name="cookie-fade">
        <div v-if="isVisible" class="cookie-banner-wrapper">
            <div class="cookie-banner-container">
                <div class="cookie-banner-content">
                    <div class="cookie-icon-wrap">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#F1E4B2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"></path>
                            <path d="M8.5 8.5v.01"></path>
                            <path d="M16 15.5v.01"></path>
                            <path d="M12 12v.01"></path>
                            <path d="M11 17v.01"></path>
                            <path d="M7 13v.01"></path>
                        </svg>
                    </div>
                    <p class="cookie-banner-text">
                        Мы используем файлы cookie для анализа посещаемости и оптимизации работы сайта.
                        Продолжая использовать сайт, вы соглашаетесь на обработку cookies в соответствии с
                        нашей политикой конфиденциальности.
                    </p>
                </div>
                <div class="cookie-banner-actions">
                    <button type="button" class="cookie-accept-btn" @click="acceptCookies">
                        Принять
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import { trackCookieConsent, updateConsentState } from '@/utils/analytics';

export default {
    name: "CookieBanner",
    data() {
        return {
            hasConsent: false
        };
    },
    computed: {
        ...mapGetters(['getUserAge']),
        isAgeConfirmed() {
            // Пользователь прошел возрастной гейт
            return Boolean(this.getUserAge || localStorage.getItem('userAge'));
        },
        isVisible() {
            return this.isAgeConfirmed && !this.hasConsent;
        }
    },
    mounted() {
        const savedConsent = localStorage.getItem('cookieConsent');
        if (savedConsent === 'granted') {
            this.hasConsent = true;
            // Ранее сохраненное согласие: обновляем состояние в gtag без генерации события клика
            updateConsentState('granted');
        } else {
            this.hasConsent = false;
        }
    },
    methods: {
        acceptCookies() {
            localStorage.setItem('cookieConsent', 'granted');
            this.hasConsent = true;
            trackCookieConsent(true);
        }
    }
};
</script>

<style scoped>
.cookie-banner-wrapper {
    position: fixed;
    bottom: 20px;
    left: 20px;
    right: 20px;
    margin: 0 auto;
    max-width: 880px;
    z-index: 9999;
    pointer-events: none;
}

.cookie-banner-container {
    pointer-events: auto;
    background: rgba(17, 75, 53, 0.96);
    border: 1px solid rgba(241, 228, 178, 0.35);
    backdrop-filter: blur(12px);
    border-radius: 12px;
    padding: 16px 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.65), 0 0 20px rgba(0, 86, 53, 0.35);
}

.cookie-banner-content {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
}

.cookie-icon-wrap {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: rgba(241, 228, 178, 0.12);
}

.cookie-banner-text {
    font-family: var(--font-family-regular, "jj2book", sans-serif);
    font-size: 14px;
    line-height: 1.5;
    color: #FFFFFF;
    margin: 0;
}

.cookie-banner-actions {
    flex-shrink: 0;
}

.cookie-accept-btn {
    background: var(--color-accent, #F1E4B2);
    color: var(--color-primary, #154734);
    font-family: var(--font-family-bold, "OswaldBold", sans-serif);
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    padding: 10px 26px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(241, 228, 178, 0.25);
    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.cookie-accept-btn:hover {
    transform: translateY(-2px);
    filter: brightness(1.08);
    box-shadow: 0 6px 16px rgba(241, 228, 178, 0.4);
}

.cookie-accept-btn:active {
    transform: translateY(1px);
    box-shadow: 0 2px 6px rgba(241, 228, 178, 0.2);
}

/* Анимация появления плашки */
.cookie-fade-enter-active,
.cookie-fade-leave-active {
    transition: opacity 0.35s ease, transform 0.35s ease;
}

.cookie-fade-enter,
.cookie-fade-leave-to {
    opacity: 0;
    transform: translateY(20px);
}

@media (max-width: 768px) {
    .cookie-banner-wrapper {
        bottom: 12px;
        left: 12px;
        right: 12px;
    }

    .cookie-banner-container {
        flex-direction: column;
        align-items: stretch;
        padding: 14px 16px;
        gap: 14px;
    }

    .cookie-banner-content {
        align-items: flex-start;
        gap: 12px;
    }

    .cookie-banner-text {
        font-size: 13px;
        line-height: 1.4;
    }

    .cookie-accept-btn {
        width: 100%;
        padding: 11px;
        text-align: center;
    }
}
</style>
